export default function QuestionItem({ question, onAnswer, userAnswer }) {
  const handleOption = (key) => {
    onAnswer({ question_id: question.id, selected_option_id: key });
  };

  const handleText = (e) => {
    onAnswer({ question_id: question.id, answer_text: e.target.value });
  };

  const handleTrueFalse = (val) => {
    onAnswer({ question_id: question.id, answer_text: val });
  };

  return (
    <div className="mb-6 p-5 border-2 border-primary rounded-xl bg-white shadow-md">
      <p className="font-poppins font-semibold text-primary mb-3">
        {question.number}. {question.question_text}
      </p>

      {/* Multiple Choice */}
      {question.question_type === "multiple_choice" && question.options && (
        <div className="grid grid-cols-1 gap-3">
          {question.options.map((opt) => (
            <label
              key={opt.id}
              className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
            >
              <input
                type="radio"
                name={`q-${question.id}`}
                value={opt.optionIndex}
                checked={userAnswer?.selected_option_id === opt.optionIndex}
                onChange={() => handleOption(opt.optionIndex)}
                className="radio radio-primary"
              />
              <span className="font-poppins">{opt.option_text}</span>
            </label>
          ))}
        </div>
      )}

      {/* Multiple Choice Multiple Answer */}
      {question.question_type === "multiple_choice_multiple_answer" &&
        question.options && (
          <div className="grid grid-cols-1 gap-3">
            {question.options.map((opt) => {
              const isSelected = userAnswer?.selected_option_ids?.includes(
                opt.optionIndex,
              );
              return (
                <label
                  key={opt.id}
                  className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
                >
                  <input
                    type="checkbox"
                    name={`q-${question.id}`}
                    value={opt.optionIndex}
                    checked={isSelected || false}
                    onChange={() => {
                      const currentSelected =
                        userAnswer?.selected_option_ids || [];
                      let newSelected;
                      if (currentSelected.includes(opt.optionIndex)) {
                        newSelected = currentSelected.filter(
                          (id) => id !== opt.optionIndex,
                        );
                      } else {
                        newSelected = [...currentSelected, opt.optionIndex];
                      }
                      onAnswer({
                        question_id: question.id,
                        selected_option_ids: newSelected,
                      });
                    }}
                    className="checkbox checkbox-primary"
                  />
                  <span className="font-poppins">{opt.option_text}</span>
                </label>
              );
            })}
          </div>
        )}

      {/* True/False */}
      {question.question_type === "true_false" && (
        <div className="flex space-x-4">
          {[true, false].map((val) => (
            <label
              key={val}
              className="flex items-center space-x-2 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
            >
              <input
                type="radio"
                name={`q-${question.id}`}
                value={val}
                checked={userAnswer?.answer_text === val}
                onChange={() => handleTrueFalse(val)}
                className="radio radio-primary"
              />
              <span className="font-poppins font-semibold">
                {val ? "TRUE" : "FALSE"}
              </span>
            </label>
          ))}
        </div>
      )}

      {/* Short Answer */}
      {question.question_type === "short_answer" && (
        <input
          type="text"
          placeholder="Ketik jawaban (1 kata)"
          value={userAnswer?.answer_text || ""}
          onChange={handleText}
          className="input input-bordered input-primary w-full font-poppins"
        />
      )}
    </div>
  );
}
